import clsx from 'clsx';

import { ButtonSkeletonProps } from '../../../components/Button/skeleton';
import ToolbarButtonSkeleton from '../../ToolbarButton/skeleton';
import { insertFormulaButtonClasses } from './styles';

export interface InsertFormulaButtonSkeletonProps extends ButtonSkeletonProps {
  classes?: Partial<typeof insertFormulaButtonClasses>;
}

const InsertFormulaButtonSkeleton = ({ className, classes, ...props }: InsertFormulaButtonSkeletonProps) => {
  return (
    <ToolbarButtonSkeleton
      {...props}
      className={clsx(
        insertFormulaButtonClasses.toolbarButton,
        classes?.toolbarButton,
        insertFormulaButtonClasses.formula,
        classes?.formula
      )}
    />
  );
};

export default InsertFormulaButtonSkeleton;
